import { Checkbox, FormControlLabel } from "@material-ui/core"
import CheckBoxIcon from "reusable/formsComp/checkbox/CheckBoxIcon"
import CheckBoxSelectedIcon from "reusable/formsComp/checkbox/CheckBoxSelectedIcon"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import { toggleShowOnlyStock } from "./wizardSlice"

type ShowStockToggleProps = {
  inverted?: boolean
}

const StyledFormControlLabel = styled(FormControlLabel)<{
  $inverted?: boolean
}>`
  margin: 16px 0 16px;
  justify-content: flex-end;
  margin-inline-start: -6px;

  .MuiFormControlLabel-label {
    font-size: 14px;
  }
`

const ShowStockToggle = ({ inverted }: ShowStockToggleProps) => {
  const { showOnlyStock } = useTypedSelector((state) => state.wizard)
  const dispatch = useAppDispatch()

  return (
    <>
      <StyledFormControlLabel
        $inverted={inverted}
        control={
          <Checkbox
            id="showStock"
            icon={<CheckBoxIcon />}
            checkedIcon={<CheckBoxSelectedIcon />}
            name="showStock"
            color="primary"
            checked={showOnlyStock}
            onChange={() => {
              dispatch(toggleShowOnlyStock())
            }}
          />
        }
        label="הצג רק אפשרויות שזמינות במלאי"
      />
    </>
  )
}

export default ShowStockToggle
